import {
  GET_LEADERBOARD_FAIL,
  GET_LEADERBOARD_REQUEST,
  GET_LEADERBOARD_SUCCESS,
} from "../../constants/Leaderboard/leaderboardConstants";

export const getLeaderboardDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LEADERBOARD_REQUEST:
      return { loading: true };
    case GET_LEADERBOARD_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case GET_LEADERBOARD_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
